/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as DraftDefs from './defs.defs'

const $nsid = 'com.sunnahsky.article.draft.updateDraft'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  draft: /*#__PURE__*/ l.ref<DraftDefs.DraftWithId>(
    (() => DraftDefs.draftWithId) as any,
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload()

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Updates an article draft using private storage (stash). If the draft ID does not point to an existing draft, this is treated as a draft creation - the same Striker-role and drafts-limit checks createDraft enforces are applied here too. Requires authentication. THIS IS A TEMPORARY UNSPECCED ROUTE, specific to this fork's article-authoring feature. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'NotAStriker',
  'ArticleDraftLimitReached',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
